import React, { useCallback, useMemo, useRef, useState } from "react";
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Selection, Summary, TotalItem, } from "devextreme-react/cjs/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { Card } from "react-bootstrap";
import { HttpStatus, UpdateInwardDataIds } from "modules/core";
import notistack from "modules/core/notistack";
import { getEcomDraftOrderList } from "./services/ecom.service";
import { BiSolidRightArrowAlt } from "react-icons/bi";

const EcomDraftOrderList = () => {
    let setSelectedRows: Array<number> = [];
    const dataGridRef = useRef<DataGrid>(null);

    const dataSource = useMemo(() => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    const parameterList = new URLSearchParams();
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }

                    const response = await getEcomDraftOrderList(parameterList);
                    return response;
                } catch (error) {
                    console.error('Data loading error:', error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    }, []);

    const handleSelectionChange = (e: any) => {
        setSelectedRows = e.selectedRowsData.map((item: any) => item.id);
    };

    const renderSerialNumber = useCallback((cellData: any) => {
        const rowIndex = cellData.rowIndex + 1 + cellData.component.pageIndex() * cellData.component.pageSize();
        return <span>{rowIndex}</span>;
    }, []);

    const updateDraftOrders = async () => {
        try {
            if (setSelectedRows.length > 0) {
                const model = new UpdateInwardDataIds();
                model.productHeaderIdList = setSelectedRows;
                // const response = await updateGoldAndDiamondInwardRecords(model);
                // if (response.status === 200) {
                //     dataGridRef.current?.instance.clearSelection();
                //     dataGridRef.current?.instance.refresh();
                //     notistack.notifyFromApi(response);
                // } else {
                //     notistack.notifyFromApi(response);
                // }
            } else {
                notistack.warning("Please Select Product");
            }
        } catch (error) {
            console.error("Failed to fetch Data:", error);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>E-com Darft Orders </h5>
                            <button onClick={updateDraftOrders} className="btn submit-btn">
                                <BiSolidRightArrowAlt size={15} />
                            </button>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            <DataGrid
                                dataSource={dataSource}
                                remoteOperations={{ groupPaging: true }}
                                showRowLines={true}
                                keyExpr="id"
                                ref={dataGridRef}
                                showBorders={true}
                                columnAutoWidth={true}
                                onSelectionChanged={handleSelectionChange}
                                onCellPrepared={(e) => {
                                    if (['data', 'header'].includes(e.rowType)) {
                                        e.cellElement.style.textAlign = 'center';
                                    }
                                }}
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);
                                }}
                            >
                                <Selection mode="multiple" />
                                <Scrolling
                                    mode='standard'
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />
                                <Pager

                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}
                                />
                                <Summary>
                                    <TotalItem
                                    // column="Sr.No."
                                    // summaryType="count"
                                    // displayFormat="Total: {0}"
                                    />
                                </Summary>
                                <Paging defaultPageSize={10} />
                                <SearchPanel visible width={240} placeholder="Search..." />

                                <Column
                                    caption="Sr.No."
                                    dataType="number"
                                    alignment="center"
                                    cellRender={renderSerialNumber}
                                />

                                <Column allowFiltering={true} dataField="storeCode" caption="Store Code" dataType="string" />
                                <Column allowFiltering={true} dataField="invoiceNo" caption="Invoice No." dataType="string" />
                                <Column allowFiltering={false} dataField="invoiceDate" caption="Invoice Date" dataType="date" format="dd/MM/yyyy" />
                                <Column allowFiltering={true} dataField="categoryName" caption="Category" dataType="string" />
                                <Column allowFiltering={true} dataField="complexityName" caption="Complexity" dataType="string" />
                                <Column allowFiltering={false} dataField="complexityValue" caption="Complexity Value" format="#,##0.000" dataType="number" />
                                <Column allowFiltering={true} dataField="huid" caption="HUID" dataType="string" />
                                <Column allowFiltering={true} dataField="styleNo" caption="Style Number" dataType="string" />
                                <Column allowFiltering={false} dataField="metalColor" caption="Metal Color" dataType="string" />
                                <Column allowFiltering={false} dataField="metalKT" caption="Metal KT" dataType="string" />
                                <Column allowFiltering={false} dataField="grossWt" caption="Gross Weight" format="#,##0.000" dataType="number" />
                                <Column allowFiltering={false} dataField="netWt" caption="Net Weight" format="#,##0.000" dataType="number" />
                                <Column allowFiltering={false} dataField="diaWt" caption="Diamond Weight" format="#,##0.000" dataType="number" />
                                <Column allowFiltering={false} dataField="colorStoneWt" caption="Color Stone Wt" format="#,##0.000" dataType="number" />
                                <Column allowFiltering={false} dataField="otherWt" caption="Other Wt" format="#,##0.000" dataType="number" />
                                <Column allowFiltering={false} dataField="qty" caption="Quantity" dataType="number" />
                                <Column allowFiltering={true} dataField="bagNo" caption="Bag No." dataType="string" />
                                <Column allowFiltering={false} dataField="dpPrice" caption="DP Price" format="#,##0.00" dataType="number" />
                                <Column allowFiltering={false} dataField="mrpPrice" caption="MRP Price" format="#,##0.00" dataType="number" />
                                {/* <Column allowFiltering={false} dataField="mrp" caption="MRP" format="#,##0.00" dataType="number" /> */}
                                <Column allowFiltering={false} dataField="diaMrp" caption="Diamond MRP" format="#,##0.00" dataType="number" />
                                <Column allowFiltering={false} dataField="goldMrp" caption="Gold MRP" format="#,##0.00" dataType="number" />
                                <Column allowFiltering={false} dataField="labMrp" caption="Lab MRP" format="#,##0.00" dataType="number" />
                                <Column allowFiltering={false} dataField="colorStonePrice" caption="Color Stone Price" format="#,##0.00" dataType="number" />
                                <Column allowFiltering={false} dataField="purchaseRate" caption="Purchase Rate" format="#,##0.00" dataType="number" />
                                <Column allowFiltering={false} dataField="size" caption="Size" format="#,##0.00" dataType="number" />
                                <Column allowFiltering={false} dataField="isSRP" caption="Is SRP" dataType="boolean"
                                    cellRender={({ data }) => <span>{data?.isSRP ? "Yes" : "No"}</span>} />
                                {/* <Column allowFiltering={false} dataField="isRepaired" caption="Repaired" dataType="boolean"
                                    cellRender={({ data }) => <span>{data?.isRepaired ? "Yes" : "No"}</span>} />
                                <Column allowFiltering={false} dataField="isSpecial" caption="Special" dataType="boolean"
                                    cellRender={({ data }) => <span>{data?.isSpecial ? "Yes" : "No"}</span>} /> */}
                            </DataGrid>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </React.Fragment >
    );
}
export default EcomDraftOrderList;